import { Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MainService } from 'src/app/modules/main/main.service';

@Component({
  selector: 'app-home-selector',
  templateUrl: './home-selector.component.html',
  styleUrls: ['./home-selector.component.scss']
})
export class HomeSelectorComponent {

  private allHomes$ = this.homesFacade.homes$.pipe(isDefined());

  homes$ = this.allHomes$.pipe(map(homes => homes.filter(h => !h.mode)));
  friendHomes$ = this.allHomes$.pipe(map(homes => homes.filter(h => h.mode === 'friend')));
  favoriteHomes$ = this.allHomes$.pipe(map(homes => homes.filter(h => h.mode === 'favorite')));

  data$ = this.homesFacade.homesSuccess$.pipe(
    switchMap(() => combineLatest({
      homes: this.homes$,
      friendHomes: this.friendHomes$,
      favoriteHomes: this.favoriteHomes$,
      currentHome: this.homesFacade.currentHome$,
    })),
  );

  constructor(
    private homesFacade: HomesFacade,
    private mainService: MainService,
  ) {}

  setCurrentHome(id: string): void {
    this.mainService.selectHome(id);
  }

}
